<template>
  <article class="gh-list-item">
    <GenerationHistoryListItemHead
      :service-name-key="serviceNameKey"
      :project-name="item.project_name"
      :datetime="item.request_datetime_ts"
    />
    <div class="gh-list-item__body">
      <div class="gh-list-item__left" :style="leftStyle">
        <div class="gh-list-item__preview gh-list-item__preview--design">
          <img
            v-for="(image, idx) in previewImages"
            :key="`${item.project_id}-img-${idx}`"
            :src="imageUrl(image)"
            class="gh-list-item__thumb"
            :class="{ 'gh-dnd-source': canDrag }"
            alt=""
            :draggable="canDrag ? 'true' : 'false'"
            @dragstart="onImageDragStart($event, image)"
            @dragend="onDragEnd"
          >
        </div>
        <button
          type="button"
          class="gh-list-item__view-all"
          @click="$emit('view-all', item.project_id)"
        >
          {{ $t(viewAllKey, { count: item.total_count }) }}
        </button>
      </div>
      <div class="gh-list-item__right">
        <GenerationHistoryMetaRows
          :fields="inlineFields"
          variant="inline"
          :can-drag-fields="canDrag"
          :drag-field-keys="missionDragKeys"
          :row-key-prefix="`design-board-${item.project_id}`"
          @field-drag-start="onMissionDragStart"
          @field-drag-end="onDragEnd"
        />
      </div>
    </div>
  </article>
</template>

<script>
import {
  getListInlineMetaFields,
  getListLeftPreview,
  getServiceNameKey,
  getViewAllLinkKey,
} from '@/shared/helpers/generationHistory';
import { GH_DRAG_SOURCE } from '@/shared/helpers/generationHistoryDrag';
import { GH_TEXT_FIELD } from '@/shared/helpers/generationHistoryAssistDrag';
import { generationHistoryCardDragMixin } from '@/shared/mixins/generationHistoryDragDropMixin';
import GenerationHistoryListItemHead from '../shared/GenerationHistoryListItemHead.vue';
import GenerationHistoryMetaRows from '../shared/GenerationHistoryMetaRows.vue';

export default {
  name: 'GenerationHistoryListItemDesignBoard',
  mixins: [generationHistoryCardDragMixin],
  components: {
    GenerationHistoryListItemHead,
    GenerationHistoryMetaRows,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      missionDragKeys: [GH_TEXT_FIELD.MISSION],
    };
  },
  computed: {
    serviceNameKey() {
      return getServiceNameKey(this.item.project_type);
    },
    viewAllKey() {
      return getViewAllLinkKey(this.item.project_type);
    },
    previewImages() {
      const preview = getListLeftPreview(this.item, this.item.project_type);
      return preview.images || [];
    },
    leftStyle() {
      const count = Math.min(this.previewImages.length, 2);
      const widthMap = { 1: 30, 2: 34 };
      const leftPercent = widthMap[count] || 34;
      return { flex: `0 0 ${leftPercent}%` };
    },
    inlineFields() {
      return getListInlineMetaFields(this.item, (key, params) => this.$t(key, params));
    },
  },
  methods: {
    imageUrl(image) {
      if (!image) {
        return '';
      }
      if (typeof image === 'string') {
        return image;
      }
      return image.url || '';
    },
    onMissionDragStart(event, field) {
      this.startGhTextDrag(event, {
        text: field && field.value,
        sourceType: GH_DRAG_SOURCE.DESIGN,
        itemId: this.item.project_id,
        field: GH_TEXT_FIELD.MISSION,
      });
    },
    onImageDragStart(event, image) {
      const url = this.imageUrl(image);
      const itemId = typeof image === 'object' && image ? image.itemId : null;
      const itemType = typeof image === 'object' && image ? image.itemType : null;
      this.startGhImageDrag(event, {
        url,
        itemId,
        itemType,
        posterIndex: 0,
        sourceType: GH_DRAG_SOURCE.DESIGN,
      });
    },
  },
};
</script>
